import { CSSObject } from "@emotion/react";
import {
  type AngelouCSS,
  type ButtonStyleOverrides,
  constants,
} from "@newsela/angelou";

import { SEARCH_PAGE_BREAKPOINTS } from "@/search/Langston/SearchPage/SearchPage.constants";

const { ui } = constants.colors;

export const backToTopButtonCss: ButtonStyleOverrides<AngelouCSS> = {
  root: {
    position: "sticky",
    top: "32px",
    marginTop: "32px",
    display: "none",

    [`@media (min-width: ${SEARCH_PAGE_BREAKPOINTS.MD}px)`]: {
      display: "block",
    },
  },
};

export const mainContentsFlexColumnCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
};

export const footerCss: CSSObject = {
  backgroundColor: ui.core[25],
  borderTop: "none",

  "& a": {
    color: ui.neutral[600],
  },
};

export const getFilterContainerPositionCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  position: "sticky",
  top: 0,
  zIndex: 2,
};

export const searchPageContainerCss: CSSObject = {
  display: "flex",
  position: "relative",
  width: "100%",
  height: "100%",
  backgroundColor: ui.core[25],

  [`@media (max-width: ${SEARCH_PAGE_BREAKPOINTS.MD}px)`]: {
    flexDirection: "column",
  },
};

export const mainContentsContainerCss: CSSObject = {
  marginBottom: "104px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "1.5rem",
  height: "100%",
  width: "100%",
};
